// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getUser = (state) => state.user
